export const APP_TITLE = "Atlas by Jigsaw | Full-Stack Edge Services";
